//
import React, { Component } from "react"
import PropTypes from "prop-types"
import {
    federalRegions,
    federalAndStates,
    // stateRegions,
    // localRegions,
    usRegions,
    euRegions,
    allRegionsExceptUS,
} from "shared/imports/regionConstants"

import { MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"

import {
    createNumericTripletMultiFilter,
    createProfileToggleSingleFilter,
    datePickerGenericFilter,
    enumSingleGenericFilter,
    textGenericFilter,
    tripletGenericFilter,
    // sorting functions
    enumValueSort,
    enumOrderSort,
    enumLabelSort,
} from "shared/search/containers/Filter/Filters"

import {
    createSelectToggleMultiFilter,
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
    multiGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    StafferFilterableListView,
    BillFilterableListView,
    SupporterFilterableListView,
    VoteFilterableListView,
    AmendmentFilterableListView,
    ArticleFilterableListView,
    PublicOrganizationFilterableListView,
    UserFilterableListView,
    IssueManagementFilterableListView,
    OfficialsAndStaffEUFilterableListView,
    PressContactFilterableListView,
    OfficialFilterableWithoutCampaignFinanceListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    DateListSelect,
    DurationSelect,
    NoteCommentTypeSelect,
    NoteDonationTypeSelect,
    NoteInteractionTypeSelect,
    NoteRelationshipTypeSelect,
} from "app/static/frontend/selects/containers/EnumSelect"

import {
    OfficeSelect,
    ContactSelect,
    PublicOrganizationSelect,
    UserSelect,
    BillSelect,
    VoteSelect,
    AmendmentSelect,
    ArticleSelect,
    StafferSelect,
    IssueManagementSelect,
    OfficialsAndStaffSelect,
    PressContactSelect,
    OfficialWithoutCampaignFinanceSelect,
} from "app/static/frontend/selects/containers/PieSelect"

export const NoteTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
NoteTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    sortBy: PropTypes.func,
    displayLabel: PropTypes.string,
}
NoteTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "noteTypeFilter",
    filterKey: "note_type__in",
    enumItems: DjangIO.app.userdata.types.NoteType.region_supported_items(),
    sortBy: enumLabelSort,
}

export const NoteDurationFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
NoteDurationFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    sortBy: PropTypes.func,
    displayLabel: PropTypes.string,
}
NoteDurationFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "noteDurationFilter",
    filterKey: "note_duration",
    enumItems: DjangIO.app.userdata.types.PossibleDurations.region_supported_items()
        .sort((a, b) => a.order - b.order)
        .map((item) => ({
            ...item,
            display_text: item.label,
        })),
    sortBy: enumOrderSort,
    selectComponent: DurationSelect,
}

export const NoteSourceTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
NoteSourceTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    sortBy: PropTypes.func,
    displayLabel: PropTypes.string,
    permissions: PropTypes.array,
}
NoteSourceTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "noteSourceTypeFilter",
    filterKey: "note_creator_type",
    enumItems: DjangIO.app.userdata.types.NoteSourceType.region_supported_items(),
    sortBy: enumValueSort,
    permissions: [
        DjangIO.app.models.PermissionType.action_center,
        DjangIO.app.models.PermissionType.consultants,
        DjangIO.app.models.PermissionType.external_relationship,
        DjangIO.app.models.PermissionType.external_interactions,
    ],
}

export const NoteInteractionTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}

export const intersectionWithInternalInteractionTypes = (filterGroup) => {
    const intersectedList = filterGroup.values.filter((item) => Userdata.internal_interaction_types.includes(item))
    return {
        ...filterGroup,
        values: intersectedList,
    }
}

NoteInteractionTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    displayLabel: PropTypes.string,
    sortBy: PropTypes.func,
    selectComponent: PropTypes.func,
}
NoteInteractionTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "noteInteractionTypeFilter",
    filterKey: "custom_interaction_type__in",
    // Filter the enumItems to just CustomInteractionTypes. Checking for the organization property isn't the best looking solution, but should work
    enumItems: DjangIO.app.userdata.types.InteractionType.items().filter(
        (type) => Boolean(type.organization_id) && !type.archived,
    ),
    sortBy: enumLabelSort,
    permissions: [
        DjangIO.app.models.PermissionType.internal_relationship,
        DjangIO.app.models.PermissionType.external_interactions,
    ],
    selectComponent: NoteInteractionTypeSelect,
    displayLabel: "Note Type",
}

export const NoteDonationTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
NoteDonationTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    sortBy: PropTypes.func,
    selectComponent: PropTypes.func,
}
NoteDonationTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "noteDonationTypeFilter",
    filterKey: "interaction_type__in",
    enumItems: DjangIO.app.userdata.types.InteractionType.region_supported_items().filter(
        (item) => item.should_display_amount,
    ),
    sortBy: enumOrderSort,
    permissions: [
        DjangIO.app.models.PermissionType.internal_relationship,
        DjangIO.app.models.PermissionType.external_interactions,
    ],
    selectComponent: NoteDonationTypeSelect,
}

export const NoteRelationshipTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
NoteRelationshipTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    displayLabel: PropTypes.string,
    sortBy: PropTypes.func,
    selectComponent: PropTypes.func,
}
NoteRelationshipTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "noteRelationshipTypeFilter",
    filterKey: "relationship_type__in",
    enumItems: DjangIO.app.userdata.types.RelationshipType.region_supported_items(),
    // dumb way to get the header we want
    enumGroups: [
        {
            title: "Relationships",
            values: DjangIO.app.userdata.types.RelationshipType.region_supported_items().map((item) => item.value),
        },
    ],
    sortBy: enumOrderSort,
    permissions: [
        DjangIO.app.models.PermissionType.internal_relationship,
        DjangIO.app.models.PermissionType.external_relationship,
    ],
    selectComponent: NoteRelationshipTypeSelect,
}

export const NoteAttachmentTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
NoteAttachmentTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
NoteAttachmentTypeFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "noteAttachmentFilter",
    filterKey: "attachment_available",
    displayLabel: "Attachments",
    trueText: "Yes",
    falseText: "No",
}

export const NoteRelationshipStatusFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
NoteRelationshipStatusFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
NoteRelationshipStatusFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "noteRelationshipStatusFilter",
    filterKey: "relationships",
    displayLabel: "Relationship Status",
    trueText: "Current",
    falseText: "Former",
    permissions: [
        DjangIO.app.models.PermissionType.internal_relationship,
        DjangIO.app.models.PermissionType.external_relationship,
    ],
}

export const NoteCommentTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
NoteCommentTypeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    enumItems: PropTypes.array,
    enumGroups: PropTypes.array,
    displayLabel: PropTypes.string,
    sortBy: PropTypes.func,
    selectComponent: PropTypes.func,
}

const regionSupportedEnumItems = DjangIO.app.models.QuorumDataType.region_supported_items()

// eslint-disable-next-line @typescript-eslint/ban-types
const commentEnumItems = [
    DjangIO.app.models.QuorumDataType.amendment,
    DjangIO.app.models.QuorumDataType.bill,
    DjangIO.app.models.QuorumDataType.document,
    DjangIO.app.models.QuorumDataType.media,
    DjangIO.app.models.QuorumDataType.outlet,
    DjangIO.app.models.QuorumDataType.person,
    DjangIO.app.models.QuorumDataType.project,
    DjangIO.app.models.QuorumDataType.public_organization,
    DjangIO.app.models.QuorumDataType.regulation,
    DjangIO.app.models.QuorumDataType.staffer,
    DjangIO.app.models.QuorumDataType.supporter,
    DjangIO.app.models.QuorumDataType.vote,
].filter((item) => regionSupportedEnumItems.includes(item))

NoteCommentTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "noteCommentTypeFilter",
    filterKey: "comment_type__in",
    enumItems: commentEnumItems,
    enumGroups: [
        {
            title: "Commented On",
            values: commentEnumItems.map((item) => item.value),
        },
    ],
    sortBy: enumValueSort,
    selectComponent: NoteCommentTypeSelect,
}

// eslint-disable-next-line @typescript-eslint/ban-types
export class NoteInvolvingParticipantsTripletFilter extends Component {
    static get defaultProps() {
        const uniqueFilterId = "noteInvolvingParticipantsTripletFilter"
        const tripletId = `${uniqueFilterId}MultiTriplet`

        // eslint-disable-next-line @typescript-eslint/ban-types
        const filterKeyMapping = {
            left: "involving_exactly_n_participants",
            center: "involving_exactly_n_participants",
            right: "involving_at_least_n_participants",
        }

        // eslint-disable-next-line @typescript-eslint/ban-types
        const valueMapping = {
            left: "1",
            center: "2",
            right: "3",
        }

        // eslint-disable-next-line @typescript-eslint/ban-types
        const triplet = class TripletFilter extends Component {
            static defaultProps = {
                filterComponent: tripletGenericFilter,
                uniqueFilterId: tripletId,
                filterKey: "",
                leftText: "1",
                centerText: "2",
                rightText: "3+",
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        return {
            uniqueFilterId,
            filterComponent: multiGenericFilter,
            displayLabel: "# of participants",
            filterKey: "",
            subfilters: [triplet],
            allFilterKeys: ["involving_n_participants"],
            computeFilterKeyFromSubfilters: (filters) => filterKeyMapping[filters.get(tripletId)],
            computeFilterValueFromSubfilters: (filters) => valueMapping[filters.get(tripletId)],
            computeSubfilterValuesFromParent: (filterKey, value) => {
                return {
                    [tripletId]: Object.keys(filterKeyMapping)
                        .filter((key) => filterKeyMapping[key] === filterKey)
                        .find((key) => valueMapping[key] === value),
                }
            },
            serializationKey: toggleGenericFilter.defaultProps.serializationKey,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const NoteInvolvingOfficeFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={OfficialFilterableWithoutCampaignFinanceListView} {...props} />
}
NoteInvolvingOfficeFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    permissions: PropTypes.array,
}
NoteInvolvingOfficeFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteInvolvingOffice",
    filterKey: "involving_office",
    dataTypeLabel: "Offices",
    selectComponent: OfficeSelect,
    permissions: [
        DjangIO.app.models.PermissionType.legislators,
        DjangIO.app.models.PermissionType.executives,
        DjangIO.app.models.PermissionType.staffers,
    ],
}

export const NoteInvolvingMemberFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={OfficialFilterableWithoutCampaignFinanceListView} {...props} />
}
NoteInvolvingMemberFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    permissions: PropTypes.array,
    regions: PropTypes.arrayOf(PropTypes.number),
}
NoteInvolvingMemberFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteInvolvingMember",
    filterKey: "involving_member",
    dataTypeLabel: "Officials",
    selectComponent: OfficialWithoutCampaignFinanceSelect,
    permissions: [
        DjangIO.app.models.PermissionType.legislators,
        DjangIO.app.models.PermissionType.executives,
        DjangIO.app.models.PermissionType.staffers,
    ],
    regions: usRegions,
}

export const NoteInvolvingStafferFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={StafferFilterableListView} {...props} />
}
NoteInvolvingStafferFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    permissions: PropTypes.array,
    regions: PropTypes.arrayOf(PropTypes.number),
}
NoteInvolvingStafferFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteInvolvingStaffer",
    filterKey: "involving_member",
    dataTypeLabel: DjangIO.app.models.QuorumDataType.staffer.plural,
    selectComponent: StafferSelect,
    permissions: [
        DjangIO.app.models.PermissionType.legislators,
        DjangIO.app.models.PermissionType.executives,
        DjangIO.app.models.PermissionType.staffers,
    ],
    regions: federalAndStates,
}

export const NoteInvolvingOfficialsAndStaffersFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={OfficialsAndStaffEUFilterableListView} {...props} />
}
NoteInvolvingOfficialsAndStaffersFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    permissions: PropTypes.array,
    regions: PropTypes.arrayOf(PropTypes.number),
}
NoteInvolvingOfficialsAndStaffersFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteInvolvingOfficialsAndStaffersFilter",
    filterKey: "involving_member",
    dataTypeLabel: DjangIO.app.models.QuorumDataType.person.plural,
    selectComponent: OfficialsAndStaffSelect,
    permissions: [
        DjangIO.app.models.PermissionType.legislators,
        DjangIO.app.models.PermissionType.executives,
        DjangIO.app.models.PermissionType.staffers,
    ],
    regions: allRegionsExceptUS,
}

export const NoteInvolvingPressContactFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={PressContactFilterableListView} {...props} />
}
NoteInvolvingPressContactFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    permissions: PropTypes.array,
    regions: PropTypes.arrayOf(PropTypes.number),
}
NoteInvolvingPressContactFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteInvolvingPressContact",
    filterKey: "involving_member",
    dataTypeLabel: DjangIO.app.models.QuorumDataType.press_contact.plural,
    selectComponent: PressContactSelect,
    permissions: [DjangIO.app.models.PermissionType.media_relations],
}

export const NoteInvolvingSupporterFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={SupporterFilterableListView} {...props} />
}
NoteInvolvingSupporterFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    permissions: PropTypes.array,
}
NoteInvolvingSupporterFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteInvolvingSupporter",
    filterKey: "involving_supporter",
    dataTypeLabel: "Contacts",
    selectComponent: ContactSelect,
    permissions: [DjangIO.app.models.PermissionType.custom_contacts],
}

export const NoteInvolvingOrganizationFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={PublicOrganizationFilterableListView} {...props} />
}
NoteInvolvingOrganizationFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
NoteInvolvingOrganizationFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteInvolvingOrg",
    filterKey: "involving_public_organization_and_associated_individuals",
    dataTypeLabel: "Organizations",
    selectComponent: PublicOrganizationSelect,
}

export const NoteInvolvingUserFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={UserFilterableListView} {...props} />
}
NoteInvolvingUserFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
NoteInvolvingUserFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteInvolvingUser",
    filterKey: "involving_user",
    dataTypeLabel: "Team Members",
    selectComponent: UserSelect,
}

export const NoteCreatorFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter

    return <FilterComponent searchifyFLV={UserFilterableListView} {...props} />
}
NoteCreatorFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
NoteCreatorFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteCreator",
    filterKey: "involving_creator",
    displayLabel: "Created By",
    dataTypeLabel: "Creator",
    selectComponent: UserSelect,
}

export const NoteProjectFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return (
        <FilterComponent
            searchifyFLV={IssueManagementFilterableListView}
            searchifyPermanentFilter={{
                can_be_tagged_to_interactions: true,
                is_limited_to_creator: false,
            }}
            {...props}
        />
    )
}
NoteProjectFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
NoteProjectFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteProjectFilter",
    filterKey: "for_project_and_subprojects",
    dataTypeLabel: "Issues",
    selectComponent: IssueManagementSelect,
}

export const NoteInIssueFilter = createSelectToggleMultiFilter({
    uniqueFilterId: "noteInIssue",
    displayLabel: "Is in my issues...",
    dataTypeLabel: "Issues",
    getSearchifyFLV: () => IssueManagementFilterableListView,
    selectComponent: IssueManagementSelect,
    filterKeyMapping: {
        true: "in_issue_or",
        false: "in_issue_and",
    },
    permanentFilter: {
        can_be_tagged_to_interactions: true,
        is_limited_to_creator: false,
    },
})

export const NoteNotInIssueFilter = createSelectToggleMultiFilter({
    uniqueFilterId: "noteNotInIssue",
    displayLabel: "Is not in my issues...",
    dataTypeLabel: "Issues",
    getSearchifyFLV: () => IssueManagementFilterableListView,
    selectComponent: IssueManagementSelect,
    filterKeyMapping: {
        true: "not_in_issue_or",
        false: "not_in_issue_and",
    },
    permanentFilter: {
        can_be_tagged_to_interactions: true,
        is_limited_to_creator: false,
    },
})

export const NoteBillMentionFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={BillFilterableListView} {...props} />
}
NoteBillMentionFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    selectLabel: PropTypes.string,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
    maxSearchifySelections: PropTypes.number,
}
NoteBillMentionFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteBillMentionFilter",
    filterKey: "involving_bills",
    selectLabel: `Choose ${DjangIO.app.models.QuorumDataType.bill.plural}...`,
    selectComponent: BillSelect,
    regions: [...federalAndStates, ...euRegions],
    maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
}

export const NoteVoteMentionFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={VoteFilterableListView} {...props} />
}
NoteVoteMentionFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    regions: PropTypes.array,
    selectComponent: PropTypes.func,
}
NoteVoteMentionFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteVoteMentionFilter",
    filterKey: "referencing_votes",
    dataTypeLabel: "Votes",
    regions: federalAndStates,
    selectComponent: VoteSelect,
}

export const NoteAmendmentMentionFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={AmendmentFilterableListView} {...props} />
}
NoteAmendmentMentionFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    regions: PropTypes.array,
    selectComponent: PropTypes.func,
}
NoteAmendmentMentionFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteAmendmentMentionFilter",
    filterKey: "referencing_amendments",
    dataTypeLabel: "Amendments",
    regions: federalRegions,
    selectComponent: AmendmentSelect,
}

export const NoteArticleMentionFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={ArticleFilterableListView} {...props} />
}
NoteArticleMentionFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    regions: PropTypes.array,
    selectComponent: PropTypes.func,
}
NoteArticleMentionFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "noteArticleMentionFilter",
    filterKey: "referencing_articles",
    dataTypeLabel: "Articles",
    regions: [...usRegions, ...allRegionsExceptUS],
    selectComponent: ArticleSelect,
}

export const NoteMentionsUserFilter = createSelectToggleMultiFilter({
    uniqueFilterId: "noteMentionsUsersFilter",
    displayLabel: "Mentions Users",
    dataTypeLabel: "Users",
    getSearchifyFLV: () => UserFilterableListView,
    selectComponent: UserSelect,
    filterKeyMapping: {
        true: "mentions_user_or",
        false: "mentions_user_and",
    },
    searchifyPermanentFilter: { data_type: DjangIO.app.models.QuorumDataType.user.value },
})

export const NoteUserOrganizationFilter = () => {
    // Do Nothing
}
NoteUserOrganizationFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    invisible: PropTypes.bool,
}
NoteUserOrganizationFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "noteUserOrgFilter",
    filterKey: "organization__in",
    invisible: true,
}

export const NoteDonationFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "noteDonationFilter",
    displayLabel: "Amount",
    filterKeyMapping: {
        left: "amount__lt",
        center: "amount",
        right: "amount__gt",
    },
})

// eslint-disable-next-line @typescript-eslint/ban-types
export class NoteStartDateFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "noteStartDateFilter",
        filterKey: "date__gt",
        displayLabel: "From Date",
        helpText: "Notes occurring after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// eslint-disable-next-line @typescript-eslint/ban-types
export class NoteEndDateFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "noteEndDateFilter",
        filterKey: "date__lt",
        displayLabel: "To Date",
        helpText: "Notes occurring before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// eslint-disable-next-line @typescript-eslint/ban-types
export class NoteCreatedDateListFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "noteCreatedDateListFilter",
        filterKey: "created_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
        sortBy: enumOrderSort,
        selectComponent: DateListSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// eslint-disable-next-line @typescript-eslint/ban-types
export class NoteCreatedStartDateFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "noteCreatedStartDateFilter",
        filterKey: "created__gt",
        displayLabel: "From Date",
        helpText: "Notes created after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// eslint-disable-next-line @typescript-eslint/ban-types
export class NoteCreatedEndDateFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "noteCreatedEndDateFilter",
        filterKey: "created__lt",
        displayLabel: "To Date",
        helpText: "Notes created before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const NoteInvolvingCurrentUserOrTeamFilter = (props) => {
    const FilterComponent = toggleGenericFilter
    return <FilterComponent {...props} />
}
NoteInvolvingCurrentUserOrTeamFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    displayLabel: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}
NoteInvolvingCurrentUserOrTeamFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "noteInvolvingCurrentUserOrTeamFilter",
    filterKey: "involving_current_user_or_team",
    trueText: "Participated in by me",
    falseText: "Participated in by my teams",
}

export const NoteCheckNumberFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "noteCheckNumberFilter",
    displayLabel: "Check Number",
    filterKeyMapping: {
        left: "check_number__lt",
        center: "check_number",
        right: "check_number__gt",
    },
})

// eslint-disable-next-line @typescript-eslint/ban-types
export class NoteCheckFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "noteCheckFilter",
        filterKey: "check_number_search",
        placeholderText: "Exact Check Number",
        displayLabel: "Exact Check Number",
        helpText: "You can search for exact check numbers, such as 00001.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// Profile-specific filters
export const NoteOrganizatonsFilter = createProfileToggleSingleFilter({
    uniqueFilterId: "noteOrganizatonsFilter",
    trueText: "Current Org Only",
    filterKeyMapping: {
        true: "involving_public_organization_and_associated_individuals",
    },
})
